import React, { useEffect, useState } from 'react';
import logo from '../../../assets/owlbot_logo_login.png';
import Footer from '../../../components/Footer/Footer';
import FlashBar from '../../../components/FlashBar/FlashBar';
import { Link, useParams } from 'react-router-dom';
import instance from '../../../service/axiosInstane';
import { flashBarTheme } from '../../../config/flashBar';
import { successMessage } from '../../../config/keyword';

const CheckMail = () => {
  const { email } = useParams();
  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const resendMail = async () => {
    await instance
      .post(`/account/send-verification-email?email=${atob(email as string)}`)
      .then((response) => {
        if (response.status === 200) {
          setFlashbar({
            ...flashbar,
            isOpen: true,
            message: successMessage.RESEND_EMAIL,
            type: flashBarTheme.SUCCESS,
          });
        }
      })
      .catch((err) => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        });
      });
  };

  return (
    <>
      <FlashBar
        message={flashbar.message}
        isOpen={flashbar.isOpen}
        type={flashbar.type}
        handleClose={() => {
          setFlashbar({ ...flashbar, isOpen: false });
        }}
      />
      <div className=" relative flex justify-center items-center h-screen bg-slate-100">
        <div className="border w-96 h-[400] p-8 flex flex-col justify-center shadow-lg rounded-sm bg-white">
          <div className="w-72 h-[400] flex flex-col justify-center text-center mx-auto rounded">
            <img src={logo} className="w-9/12 mx-auto my-0 " />
            <div className="text-3xl pb-2 pt-2">
              <i className="fa-solid text-[50px] fa-envelope-circle-check text-[green]"></i>
            </div>
            <div className="text-[14px] ">
              Email need to be verified, Please check your inbox!
            </div>
            <div className="mt-3">
              <div className="p-2 text-sm text-center flex justify-center gap-2 items-center">
                <div
                  className={`${
                    minutes === 0 && seconds === 0
                      ? 'text-blue-800 cursor-pointer'
                      : 'text-blue-200'
                  }  `}
                  onClick={resendMail}
                >
                  Resend Email
                </div>
                {minutes > 0 ||
                  (seconds > 0 && (
                    <p className="text-sm">
                      in {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ))}
              </div>
            </div>
            <Link
              to={'/'}
              className="text-center text-blue-800 text-sm cursor-pointer hover:underline"
            >
              Back to login
            </Link>
          </div>
        </div>
        <div className="absolute right-0 bottom-0">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default CheckMail;
